module.exports = __webpack_public_path__ + "img/2.4269db50.png";